import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class RequestServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
}

export const RequestService = new RequestServiceClass({
  api_version: 2,
  resource: 'referrals/orders'
});
